import { useSidebar } from "@/components/ui/sidebar";
// import { useEffect } from "react";

type SidebarAwareLayoutProps = {
  children: React.ReactNode;
};

const SidebarAwareLayout = ({ children }: SidebarAwareLayoutProps) => {
  const { open, isMobile } = useSidebar();
  const marginLeft = !isMobile && open ? "var(--sidebar-width)" : 0;

  // useEffect(() => {
  //   const layoutDiv = document.getElementById("tpr-sidebar-layout");
  //   if (layoutDiv) {
  //     const sidebarWidth = getComputedStyle(layoutDiv).getPropertyValue("--sidebar-width");
  //     console.log("CSS --sidebar-width:", sidebarWidth);
  //   }
  // }, [open, isMobile]);

  // console.log("Sidebar open state:", open);

  return (
    <div id="tpr-sidebar-layout" style={{ marginLeft }} className="flex flex-col min-h-screen">
      {children}
    </div>
  );
};

export default SidebarAwareLayout;
